import React, { lazy, Suspense } from 'react';
import { useClassName } from 'common/hooks';
import './card.less';
import './card-l.less';
import { ContentfulRichText } from 'common/components';
import HomepageAsset from '../Asset';
import CardTypeV from './CardTypeV';
//For avoiding circular dependeny issues
const Carousel = lazy(() => import('../Carousel'));

export default function CardTypeL({ item, refs, handleTrack }) {
  const classNames = useClassName('CLPCardTypeL');
  const itemDetails = item.fields.itemDetails?.fields?.items || [];

  return (
    <div className={classNames('container')}>
      <div className={classNames('main')}>
        <div className={classNames('content')}>
          <div className={classNames('title-container')}>
            <p className={classNames('title')}>{item.fields.title}</p>
            <div className={classNames('description')}>
              <ContentfulRichText
                field={{ 'en-US': item.fields.description }}
              />
            </div>
          </div>

          <div className={classNames('labels-container')}>
            <p className={classNames('subtitle')}>{item.fields.subtitle}</p>
            <div className={classNames('labels')}>
              {(item.fields.labels || []).map((label) => (
                <div key={label} className={classNames('label')}>
                  {label}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={classNames('gallery')}>
          {item.fields.carousel ? (
            <Suspense fallback={<></>}>
              <Carousel component={item.fields.carousel} />
            </Suspense>
          ) : (
            <HomepageAsset
              asset={item.fields.asset}
              settings={item.fields.settings}
            />
          )}
        </div>
      </div>
      {Boolean(itemDetails.length) && (
        <div className={classNames('item-details')}>
          {itemDetails.map((detail) => (
            <CardTypeV
              key={detail.sys.id}
              item={detail}
              refs={refs}
              handleTrack={handleTrack}
            />
          ))}
        </div>
      )}
    </div>
  );
}
